import React from "react";
import { Card, Col, Row, Select } from "antd";
import { LineChart } from ".";

const RevenueChart = (props: any) => {
  const handleFilterChange = (value: string) => {
    props.onFilterChange(value);
    props.setName("left");
  };

  return (
    <div style={{ padding: 0 }}>
      <Card className="chart_card">
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <h2>Revenue Generated</h2>
          <div style={{ width: "20%" }}>
            <Select
              style={{ width: "100%" }}
              onChange={handleFilterChange}
              defaultValue={"monthly"}
              placeholder="Filter"
              options={[
                { value: "daily", label: "Daily" },
                { value: "weekly", label: "Weekly" },
                { value: "monthly", label: "Monthly" },
                { value: "yearly", label: "Yearly" },
              ]}
            />
          </div>
        </div>
        <div style={{ margin: "auto" }}>
          <LineChart data={props.graphData} />
        </div>
      </Card>
    </div>
  );
};

export default RevenueChart;
